module.exports = __webpack_public_path__ + "img/AF_logo.6bf7b623.png";